.wrapper {
  position: absolute;
  top: 13px;
  right: 7px;
  padding: 0 10px;
  opacity: 0;
  color: white;
  font-size: 11px;
  font-weight: 700;
  line-height: 22px;
  white-space: nowrap;
  background: black;
  border-radius: 2px;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  transform: translateX(26px);
  pointer-events: none;
  z-index: 10;

  &.isVisible {
    transform: translateX(0);
    opacity: 1;
  }

  &:before {
    position: absolute;
    content: '';
    height: 0;
    width: 0;
    left: -10px;
    border: 5px solid transparent;
    border-right-color: black;
    margin-top: 7px;
  }
}

